import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';

const DialogDataMLStyled = styled(Dialog)`
  .MuiPaper-root {
    min-width: 320px;
    min-height: 180px;
    max-width: none;
    .MuiDialogTitle-root {
      font-weight: 500;
      min-height: 64px;
      font-size: 24px;
    }
    .MuiDialogContent-root {
      color: #212121;
      padding-top: 8px;
      padding-bottom: 8px;
      p {
        color: #212121;
        line-height: 24px;
      }
      .Mui-error {
        color: #f44336;
      }
    }
    .MuiDialogActions-root {
      margin-top: ${(props) =>
        props?.button?.top ? props?.button?.top : '24px'};
      height: ${(props) =>
        props?.button?.height ? props.button.height : '52px'};
      .MuiButton-root {
        height: 36px;
        width: 48px;
        min-width: 48px;
      }
    }
  }
  .warning {
    color: rgb(215, 33, 33);
  }
  .mini_background {
    background: ${(props) =>
      `url(${props?.params?.backgroundUrl}) 0 0 no-repeat`};
    background-size: cover;
  }
  .text-input-align-style input {
    text-align: right;
  }
  .material-list-preview {
    input:focus {
      outline: none; /* 移除默认轮廓 */
      border-color: transparent; //透明
    }
  }
`;
export default DialogDataMLStyled;
